// extracted by mini-css-extract-plugin
export default {"heading":"xj-z","list":"yj-z"};